"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M17 18H7V6h7V1H5v22h14v-7h-2z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "m18 14 5-5-1.41-1.41L19 10.17V3h-2v7.17l-2.59-2.58L13 9z"
}, "1")], 'InstallMobileSharp');